

































import { Component, Vue } from 'vue-property-decorator';
import OccupationSelectionDeleteButton from '@/components/Occupation/OccupationSelectionDeleteButton.vue';
import { OCCUPATION_SELECTIONS } from './occupationSelection';

@Component({
  components: {
    OccupationSelectionDeleteButton,
  },
})
export default class OccupationSelectionList extends Vue {
  private OCCUPATION_SELECTIONS = OCCUPATION_SELECTIONS;
}
